module.exports = __webpack_public_path__ + "static/dochq-brochure-5f6696fb60f1a8673d7d3cfca7007382.pdf";